import { Link } from 'office-ui-fabric-react';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { SrOnlyText } from '../SrOnlyText/SrOnlyText';
import { PeopleDetailSection } from '../PeopleDetailSection/PeopleDetailSection';
import { linkNoHoverColor } from '../../Styles';
import { body1Font } from '../Typography/Typography';

export interface IPeopleDetailHistoryProps {
  title: string;
  profileLink?: string;
  recordsToDisplay?: number;
  children?: ReactNode;
}

const StyledLink = styled(Link)`
  margin-left: 60px;
  margin-top: 18px;
  ${body1Font}
  display: inline-block;
  padding: 5px;
  position: relative;
  left: -5px;
  ${linkNoHoverColor}
`;

export const PeopleDetailHistory: FunctionComponent<IPeopleDetailHistoryProps> = props => {
  const { title, recordsToDisplay = 3, profileLink, children } = props;
  let childrenToDisplay = children;
  let viewMoreLink = null;
  const numChildren = React.Children.count(children);

  if (numChildren > recordsToDisplay) {
    childrenToDisplay = React.Children.map(children, (child, i) => {
      return i < recordsToDisplay ? child : null;
    });

    if (profileLink) {
      viewMoreLink = (
        <StyledLink className="global-link" href={profileLink} target="_blank">
          {`${numChildren - recordsToDisplay} more on LinkedIn`} <SrOnlyText>Opens LinkedIn in new window.</SrOnlyText>
        </StyledLink>
      );
    }
  }

  return (
    <PeopleDetailSection title={title}>
      {childrenToDisplay}
      {viewMoreLink}
    </PeopleDetailSection>
  );
};

export default PeopleDetailHistory;
